import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const VehicleForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  return (
    <div className={tw`grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
      <TextField
        label={"Emergency Contact Number"}
        register={register("emergency_contact_number")}
        errors={errors?.emergency_contact_number}
      />
      <TextField
        label={"Vehicle Number"}
        register={register("license_number")}
        errors={errors?.license_number}
      />
      <ComboboxInput
        url={APIS.VEHILCE_CATEGORY}
        queryKey={"vehicle-category"}
        register={register("vehicle_category")}
        errors={errors?.vehicle_category}
        name={"vehicle_category"}
        label={" Category"}
        props={{
          is_active: true,
        }}
        setValue={setValue}
        placeholder={"Select category"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <ComboboxInput
        url={APIS.VEHILCE_TYPE}
        queryKey={"vehicle-type"}
        register={register("vehicle_type")}
        errors={errors?.vehicle_type}
        name={"vehicle_type"}
        label={" Type"}
        props={{
          is_active: true,
        }}
        setValue={setValue}
        placeholder={"Select type"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <TextField
        label={"Insurance Comapny"}
        register={register("insurance_company")}
        errors={errors?.insurance_company}
      />
      <TextField
        label={"Insurance Company Contact Number"}
        register={register("insurance_company_contact_number")}
        errors={errors?.insurance_company_contact_number}
      />
      <TextField
        label={"Samiti Name"}
        register={register("samiti_name")}
        errors={errors?.samiti_name}
      />
      <TextField
        label={"Samiti Contact Number"}
        register={register("samiti_contact_number")}
        errors={errors?.samiti_contact_number}
      />
      <TextField
        label={"Chaises No."}
        register={register("chaises_no")}
        errors={errors?.chaises_no}
      />
    </div>
  );
};

export default VehicleForm;
